import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  buttonPage: {
    backgroundColor: "transparent",
    minWidth: "44px",
    width: "44px",
    height: "44px",
    textAlign: "center",
    borderTop: "1px solid #e4e7ec !important",
    borderBottom: "1px solid #e4e7ec !important",
    borderRight: "1px solid #e4e7ec !important",
    borderLeft: "none !important",
    borderRadius: 0,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: "0em",
    color: "#667085",
  },
  buttonPageFirst: {
    borderRadius: "0px !important",
    borderLeft: "1px solid #e4e7ec !important",
    borderTopLeftRadius: "5px !important",
    borderBottomLeftRadius: "5px !important",
  },
  buttonPageNext: {
    borderRadius: "0px !important",
    borderTopRightRadius: "5px !important",
    borderBottomRightRadius: "5px !important",
  },
  textFooterShowInfo: {
    color: "#667085",
    fontFamily: "Manrope",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "16px",
  },
  buttonSelected: {
    color: "#308CDB",
  },
}));

export default styles;
